<template>
    <div class="banner__container">
        <component
            :is="bannerComponent"
            v-for="(banner, index) in visibleBanners"
            :key="index"
            class="banner"
            v-bind="banner"
            @click="onClick"
        />
    </div>
</template>

<script>
    import Vue from 'vue';
    import { shuffle as _shuffle } from '@lodash';
    import { ActionType, BannerCategory } from '@core/models/banners/enums';
    import PromotionBanner from './components/PromotionBanner.vue';
    import SkyscraperBanner from './components/SkyscraperBanner.vue';
    import QuickLinkBanner from './components/QuickLinkBanner.vue';
    import BannerContainerMixin from './BannerContainerMixin.ts';


    export default Vue.component('SimpleBannerContainer', {
        mixins: [BannerContainerMixin],
        props: {
            banners: {
                type: Array,
                required: true,
            },
            bannersShown: {
                type: Number,
                required: false,
                default: 1,
            },
            type: {
                type: String,
                required: true,
            }
        },
        computed: {
            visibleBanners() {
                // if shown banners are skyscrapers, pick one randomly
                if (this.type === BannerCategory.skyscrapers) {
                    return _shuffle(this.banners).slice(0, this.bannersShown);
                }
                // show n selected banners (n=bannersShown)
                return this.banners.slice(0, this.bannersShown);
            },
            bannerComponent() {
                switch (this.type) {
                    case BannerCategory.promotions:
                        return PromotionBanner;
                    case BannerCategory.skyscrapers:
                        return SkyscraperBanner;
                    case BannerCategory.quickLinks:
                        return QuickLinkBanner;
                    default:
                        return null;
                }
            }
        },
        methods: {
            onClick({ link, actionType }) {
                switch (actionType) {
                    case ActionType.openNewTab:
                        this.openNewTab(link);
                        break;
                    case ActionType.openInAppLink:
                        this.goToPage(link);
                        break;
                    case ActionType.openPopup:
                        this.openPopup();
                        break;
                    default:
                        break;
                }
            },
            openNewTab(link) {
                window.open(link, '_blank');
            },
            goToPage(link) {
                this.$router.push(link);
            },
            openPopup() {
                // TODO: v2+
            }
        },
    });
</script>



// WEBPACK FOOTER //
// src/app/modules/shared/banners/SimpleBannerContainer.vue